const homepage = {
  path: 'homepage',
  component: resolve => require(['../../../../components/pages/studentresults/homepage'], resolve)
}

export default homepage
